export const ErrorBox = ({ text }: { text: string }) => (
  <div className="text-sm-multiline rounded-xl bg-error-01 px-6 py-4 text-error-05">
    {text}
  </div>
);
